export const DOMAIN_COLOR = '#ddd';

export function findLayerWithName(spec, name) {
  return spec.layer.find((layer) => {
    if (layer.name === name) {
      return true;
    }

    if (layer.layer) {
      return findLayerWithName(layer.layer, name);
    }

    return false;
  });
}

export function canonicalizeLayerName(layerName) {
  return layerName.replace(/-/g, '_');
}
